export const sx = {
    root:{
        padding: {
            xs: '0 15px'
        },
    }
}